export default "__VITE_ASSET__C1TnCO_u__"